<template>
  <div>
    <info v-if="event" :event="event"></info>
    <tickets v-if="event" :event="event" :eventBooking="eventBooking"></tickets>
    <bookerform v-if="event" :event="event" :regUserId="eventBooking.registered_user_id"></bookerform>
    <page-summary v-if="event" :event="event" headerText="Summary"></page-summary>
    <button-panel v-if="event && !expired"></button-panel>
    <org-events v-if="event && event.organisation_id != 3251" :event="event"></org-events>
    <sponsor-view v-if="event" :event="event"></sponsor-view>
  </div>
</template>

<script>
import info from "./main_booking/info.vue";
import tickets from "./main_booking/tickets.vue";
import bookerForm from "./main_booking/booker-form.vue";
import pageSummary from "./main_booking/page-summary.vue";
import buttonPanel from "./main_booking/book-button-panel.vue";
import orgEvents from "../common/org-events.vue";
import sponsorView from "../common/sponsor-view.vue";
import moment from "moment";

export default {
  data: function() {
    return {
      event: this.$store.getters.getEvent,
      eventBooking: this.$store.getters.getEventBooking,
      expired: false
    };
  },

  components: {
    info: info,
    tickets: tickets,
    bookerform: bookerForm,
    pageSummary: pageSummary,
    buttonPanel: buttonPanel,
    orgEvents: orgEvents,
    sponsorView: sponsorView

  },

  created() {
    this.expired = moment(this.event.datetimeto).isBefore(new Date(), "hour");

    if (this.expired) {
      this.$swal({
        title: "This event has expired and can no longer be booked",
        confirmButtonColor: "#FF9500"
      });
    }

    if (this.event.close_date) {
      this.closed = moment(this.event.close_date).isBefore(new Date(), "day");

      if (this.closed) {
        this.expired = true;
        this.$swal({
          title: "This event has closed and can no longer be booked",
          confirmButtonColor: "#FF9500"
        });
      }
    }

    var urlParams = new URLSearchParams(window.location.search);
    var referrer = urlParams.get('referrer');
    if(referrer){
      this.$store.commit("setExtWebsite", document.referrer);
    }
    this.$store.commit("setExpired", this.expired);
  }
};
</script>

<style>
.invalid-feedback {
  display: block !important;
}
</style>
